import CompanyInfoPage from "../../pages/legacy/companyInfo/CompanyInfoPage";

const route = {
  key: "companyInfo",
  path: "/legacy/company-info",
  component: CompanyInfoPage,
  private: true,
  layout: "main",
  icon: "faBuilding",
  group: "system",
  order: 10,
  permission: "legacy.companyInfo.read"
};

export default route;